export function formatBRL(value: number): string {
  return `R$ ${value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function parseBRL(str: string): number {
  const cleaned = str.replace(/[R$\s.]/g, '').replace(',', '.');
  return parseFloat(cleaned) || 0;
}

export function numeroParaExtensoDinheiro(valor: number | string): string {
  let inteira: number;
  let decimal: number;

  if (typeof valor === 'string' && valor.includes(',')) {
    const partes = valor.split(',');
    const parteInteiraLimpa = partes[0].replace(/\./g, '');
    inteira = Number(parteInteiraLimpa);
    let parteDecimal = partes[1] || '0';
    if (parteDecimal.length === 1) parteDecimal += '0';
    else if (parteDecimal.length > 2) parteDecimal = parteDecimal.slice(0, 2);
    decimal = Number(parteDecimal);
  } else {
    if (typeof valor === 'string') valor = parseFloat(valor.replace(',', '.'));
    const parts = (valor as number).toFixed(2).split('.').map(Number);
    inteira = parts[0];
    decimal = parts[1];
  }

  const unidades = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove', 'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove'];
  const dezenas = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa'];
  const centenas = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos', 'seiscentos', 'setecentos', 'oitocentos', 'novecentos'];
  const escalas = ['', 'mil', 'milhões', 'bilhões', 'trilhões'];

  const grupoParaExtenso = (grupo: number): string => {
    let extenso = '';
    if (grupo === 100) return 'cem';
    if (grupo > 99) extenso += centenas[Math.floor(grupo / 100)];
    grupo %= 100;
    if (grupo > 19) {
      if (extenso) extenso += ' e ';
      extenso += dezenas[Math.floor(grupo / 10)];
      grupo %= 10;
    }
    if (grupo > 0) {
      if (extenso) extenso += ' e ';
      extenso += unidades[grupo];
    }
    return extenso;
  };

  if (isNaN(inteira) || inteira < 0) throw new Error('Valor inválido');

  const valorStr = inteira.toString().padStart(3, '0');
  const grupos: number[] = [];
  for (let i = valorStr.length; i > 0; i -= 3) {
    grupos.unshift(parseInt(valorStr.substring(Math.max(0, i - 3), i)));
  }

  let extensoInteiro = grupos
    .map((grupo, idx) => {
      if (grupo === 0) return '';
      let escala = escalas[grupos.length - idx - 1];
      if (escala && grupo === 1) {
        if (escala === 'milhões') escala = 'milhão';
        if (escala === 'bilhões') escala = 'bilhão';
        if (escala === 'trilhões') escala = 'trilhão';
      }
      return grupoParaExtenso(grupo) + (escala ? ' ' + escala : '');
    })
    .filter(Boolean)
    .join(', ');

  if (!extensoInteiro) extensoInteiro = 'zero';

  const moedaTexto = inteira === 1 ? ' real' : ' reais';
  let resultado = extensoInteiro + moedaTexto;

  if (decimal > 0) {
    const centavosTexto = decimal === 1 ? ' centavo' : ' centavos';
    resultado += ' e ' + grupoParaExtenso(decimal) + centavosTexto;
  }

  return resultado;
}
